import { render, staticRenderFns } from "./SuitEditor.vue?vue&type=template&id=1e8224a8&scoped=true&"
import script from "./SuitEditor.vue?vue&type=script&lang=js&"
export * from "./SuitEditor.vue?vue&type=script&lang=js&"
import style0 from "./SuitEditor.vue?vue&type=style&index=0&id=1e8224a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8224a8",
  null
  
)

export default component.exports